export interface SalesContractLineQuickCreate {
  salesContractHeaderId: string;
  productId: string;
  description: string;
  quantity: number;
  price: number;
}
